import * as React from 'react';
import { Col, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { CourseProviderEdit } from '../../api';
import { EditingName } from '../../views/cpProfile/CPProfile';
import { CPItemEditComponent, EditState } from './CPItemEditComponent';
import { CPItemWarning } from './CPItemWarning';

export interface CPAdressProps {
    courseProvider: CourseProviderEdit;
    cancelHandler: () => void;
    className?: string;
    editHandler: () => void;
    editItemKey: string | undefined;
    error?: boolean;
    errorMessage?: string;
    saveAdress: (
        a: string,
        b: string,
        c: string,
        d: boolean,
        e: string,
        f: string,
        g: string,
        h: string,
        i: string,
        j: string,
        k: string,
        l: string,
        m: string
    ) => void;
}

export interface CPAdressState {
    invoiceAddress: boolean;
    companyName: string;
    city: string;
    country: string;
    invoiceCompany: string;
    invoiceCity: string;
    invoiceCountry: string;
    invoiceFirstName: string;
    invoiceLastName: string;
    invoiceStreet: string;
    invoiceZip: string;
    street: string;
    zip: string;
    validationError: boolean;
}

export default class CPAdress extends React.PureComponent<CPAdressProps, CPAdressState> {
    constructor(props: CPAdressProps) {
        super(props);
        this.state = {
            city: '',
            companyName: '',
            country: '',
            invoiceAddress: false,
            invoiceCity: '',
            invoiceCompany: '',
            invoiceCountry: '',
            invoiceFirstName: '',
            invoiceLastName: '',
            invoiceStreet: '',
            invoiceZip: '',
            street: '',
            validationError: false,
            zip: '',
        };
    }

    public componentWillReceiveProps() {
        this.setState({
            city: this.props.courseProvider.City,
            companyName: this.props.courseProvider.CompanyName,
            country: this.props.courseProvider.Country,
            invoiceAddress: this.props.courseProvider.InvoiceAddress,
            invoiceCity: this.props.courseProvider.InvoiceCity,
            invoiceCompany: this.props.courseProvider.InvoiceCompany,
            invoiceCountry: this.props.courseProvider.InvoiceCountry,
            invoiceFirstName: this.props.courseProvider.InvoiceFirstName,
            invoiceLastName: this.props.courseProvider.InvoiceLastName,
            invoiceStreet: this.props.courseProvider.InvoiceStreet,
            invoiceZip: this.props.courseProvider.InvoiceZip,
            street: this.props.courseProvider.Street,
            zip: this.props.courseProvider.Zip,
        });
    }

    public render() {
        const {
            city,
            companyName,
            country,
            invoiceAddress,
            invoiceCity,
            invoiceCompany,
            invoiceCountry,
            invoiceFirstName,
            invoiceLastName,
            invoiceStreet,
            invoiceZip,
            street,
            zip,
        } = this.state;
        return (
            <CPItemEditComponent
                name="Anschrift"
                editHandler={this.props.editHandler}
                saveHandler={() => {
                    if (
                        city.length < 3 ||
                        country.length < 3 ||
                        street.length < 3 ||
                        zip.length < 3 ||
                        (invoiceAddress
                            ? invoiceFirstName.length < 3 ||
                              invoiceLastName.length < 3 ||
                              invoiceStreet.length < 3 ||
                              invoiceZip.length < 3 ||
                              invoiceCity.length < 3 ||
                              invoiceCountry.length < 3
                            : false)
                    ) {
                        this.setState({ validationError: true });
                    } else {
                        this.setState({ validationError: false }, () => {
                            this.props.saveAdress(
                                city,
                                companyName,
                                country,
                                invoiceAddress,
                                invoiceCity,
                                invoiceCompany,
                                invoiceCountry,
                                invoiceFirstName,
                                invoiceLastName,
                                invoiceStreet,
                                invoiceZip,
                                street,
                                zip
                            );
                        });
                    }
                }}
                cancelHandler={this.props.cancelHandler}
                content={this.renderContent()}
                contentEdit={this.renderContentEdit()}
                editState={this.editStateThisComponent()}
                error={this.props.error}
                errorMessage={this.props.errorMessage}
                validationError={this.state.validationError}
                validationMessage={this.state.validationError ? TR.cPAdress_check_data : ''}
            />
        );
    }

    private editStateThisComponent() {
        let myEditState: EditState;
        if (this.props.editItemKey === EditingName.Adress) {
            myEditState = EditState.This;
        } else if (this.props.editItemKey === undefined) {
            myEditState = EditState.None;
        } else {
            myEditState = EditState.Other;
        }
        return myEditState;
    }

    private renderContent = () => {
        if (
            !this.props.courseProvider.Street ||
            !this.props.courseProvider.Zip ||
            !this.props.courseProvider.City ||
            !this.props.courseProvider.Country ||
            (this.state.invoiceAddress
                ? !this.props.courseProvider.InvoiceFirstName ||
                  !this.props.courseProvider.InvoiceLastName ||
                  !this.props.courseProvider.InvoiceStreet ||
                  !this.props.courseProvider.InvoiceZip ||
                  !this.props.courseProvider.InvoiceCity ||
                  !this.props.courseProvider.InvoiceCountry
                : false)
        ) {
            return (
                <Col className="mt-2">
                    <CPItemWarning errorMessage={TR.cPAdress_missing_entry} />
                </Col>
            );
        } else {
            return (
                <>
                    {this.props.courseProvider.CompanyName !== '' && (
                        <>
                            <Col md={4} className="mt-2 mb-2">
                                {TR.cPAdress_company_name}
                            </Col>
                            <Col md={8} className="mt-2 mb-2">
                                {this.props.courseProvider.CompanyName}
                            </Col>
                        </>
                    )}
                    <Col md={4} className="mt-2 mb-2">
                        {TR.cPAdress_company_address}
                    </Col>
                    <Col md={8} className="mt-2 mb-2">
                        {this.props.courseProvider.Street}
                        <br />
                        {this.props.courseProvider.Zip},&nbsp;{this.props.courseProvider.City}
                        <br />
                        {this.props.courseProvider.Country}
                    </Col>
                    {this.props.courseProvider.InvoiceAddress && (
                        <>
                            <Col md={12} className="mt-3 mb-2">
                                <h5>{TR.cPAdress_different_invoice_address}</h5>
                            </Col>
                            {this.props.courseProvider.InvoiceCompany !== '' && (
                                <>
                                    <Col md={4} className="mt-2 mb-2">
                                        {TR.cPAdress_company_name}
                                    </Col>
                                    <Col md={8} className="mt-2 mb-2">
                                        {this.props.courseProvider.InvoiceCompany}
                                    </Col>
                                </>
                            )}
                            <Col md={4} className="mt-2 mb-2">
                                {TR.cPAdress_invoice_recipient}
                            </Col>
                            <Col md={8} className="mt-2 mb-2">
                                {this.props.courseProvider.InvoiceFirstName}&nbsp;
                                {this.props.courseProvider.InvoiceLastName}
                            </Col>
                            <Col md={4} className="mt-2 mb-2">
                                {TR.cPAdress_invoice_address}
                            </Col>
                            <Col md={8} className="mt-2 mb-2">
                                {this.props.courseProvider.InvoiceStreet}
                                <br />
                                {this.props.courseProvider.InvoiceZip},&nbsp;{this.props.courseProvider.InvoiceCity}
                                <br />
                                {this.props.courseProvider.InvoiceCountry}
                            </Col>
                        </>
                    )}
                </>
            );
        }
    };

    private renderContentEdit = () => {
        return (
            <>
                <Row>
                    <Col md={6} className="mb-1">
                        <Label>Firmenname (optional)</Label>
                        <Input
                            bsSize={'sm'}
                            id="companyName"
                            name="companyName"
                            type="text"
                            placeholder={TR.cPAdress_company_name2}
                            defaultValue={this.props.courseProvider.CompanyName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const value = e.currentTarget.value;
                                this.setState({ companyName: value });
                            }}
                        />
                    </Col>
                    <Col md={6} />
                    <Col md={3} className="mb-2">
                        <Label style={{ color: this.state.street.length < 3 ? 'red' : 'inherit' }}>
                            Straße + Hausnr.
                        </Label>
                        <Input
                            style={{ border: this.state.street.length < 3 ? '1px solid red' : 'inherit' }}
                            bsSize={'sm'}
                            autoFocus={true}
                            id="street"
                            name="street"
                            type="text"
                            placeholder="Straße"
                            defaultValue={this.props.courseProvider.Street}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={3} className="mb-2">
                        <Label style={{ color: this.state.zip.length < 3 ? 'red' : 'inherit' }}>
                            {TR.cPAdress_postal_code}
                        </Label>
                        <Input
                            style={{ border: this.state.zip.length < 3 ? '1px solid red' : 'inherit' }}
                            bsSize={'sm'}
                            id="zip"
                            name="zip"
                            type="text"
                            placeholder="PLZ"
                            defaultValue={this.props.courseProvider.Zip}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={3} className="mb-2">
                        <Label style={{ color: this.state.city.length < 3 ? 'red' : 'inherit' }}>
                            {TR.cPAdress_city}
                        </Label>
                        <Input
                            style={{ border: this.state.city.length < 3 ? '1px solid red' : 'inherit' }}
                            bsSize={'sm'}
                            id="city"
                            name="city"
                            type="text"
                            placeholder="Ort"
                            defaultValue={this.props.courseProvider.City}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={3} className="mb-2">
                        <Label style={{ color: this.state.country.length < 3 ? 'red' : 'inherit' }}>
                            {TR.cPAdress_country}
                        </Label>
                        <Input
                            style={{ border: this.state.country.length < 3 ? '1px solid red' : 'inherit' }}
                            bsSize={'sm'}
                            id="country"
                            name="country"
                            type="text"
                            placeholder="Land"
                            defaultValue={this.props.courseProvider.Country}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={12} className="mb-2">
                        <Input
                            className="mr-1"
                            name={`invoiceAddress checkbox`}
                            type="checkbox"
                            checked={this.state.invoiceAddress}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState({ invoiceAddress: e.currentTarget.checked });
                            }}
                        />
                        <label>{TR.cPAdress_different_address}</label>
                    </Col>
                    {this.state.invoiceAddress && (
                        <>
                            <Col md={12} className="mb-1">
                                <h5>{TR.cPAdress_different_address}</h5>
                            </Col>

                            <Col md={4} className="mb-1">
                                <Label>{TR.cPAdress_company_name3}</Label>
                                <Input
                                    bsSize={'sm'}
                                    id="invoiceCompany"
                                    name="invoiceCompany"
                                    type="text"
                                    placeholder="Firmenname"
                                    defaultValue={this.props.courseProvider.InvoiceCompany}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        const value = e.currentTarget.value;
                                        this.setState({ invoiceCompany: value });
                                    }}
                                />
                            </Col>
                            <Col md={4} className="mb-1">
                                <Label style={{ color: this.state.invoiceFirstName.length < 3 ? 'red' : 'inherit' }}>
                                    {TR.cPAdress_first_name}
                                </Label>
                                <Input
                                    style={{
                                        border: this.state.invoiceFirstName.length < 3 ? '1px solid red' : 'inherit',
                                    }}
                                    bsSize={'sm'}
                                    id="invoiceFirstName"
                                    name="invoiceFirstName"
                                    type="text"
                                    placeholder="Vorname"
                                    defaultValue={this.props.courseProvider.InvoiceFirstName}
                                    onChange={this.inputHandler}
                                />
                            </Col>
                            <Col md={4} className=" mb-1">
                                <Label style={{ color: this.state.invoiceLastName.length < 3 ? 'red' : 'inherit' }}>
                                    {TR.cPAdress_last_name}
                                </Label>
                                <Input
                                    style={{
                                        border: this.state.invoiceLastName.length < 3 ? '1px solid red' : 'inherit',
                                    }}
                                    bsSize={'sm'}
                                    id="invoiceLastName"
                                    name="invoiceLastName"
                                    type="text"
                                    placeholder="Nachname"
                                    defaultValue={this.props.courseProvider.InvoiceLastName}
                                    onChange={this.inputHandler}
                                />
                            </Col>
                            <Col md={3} className=" mb-1">
                                <Label style={{ color: this.state.invoiceStreet.length < 3 ? 'red' : 'inherit' }}>
                                    {TR.cPAdress_street_house_number}
                                </Label>
                                <Input
                                    style={{
                                        border: this.state.invoiceStreet.length < 3 ? '1px solid red' : 'inherit',
                                    }}
                                    bsSize={'sm'}
                                    id="invoiceStreet"
                                    name="invoiceStreet"
                                    type="text"
                                    placeholder="Straße"
                                    defaultValue={this.props.courseProvider.InvoiceStreet}
                                    onChange={this.inputHandler}
                                />
                            </Col>
                            <Col md={3} className=" mb-1">
                                <Label style={{ color: this.state.invoiceZip.length < 3 ? 'red' : 'inherit' }}>
                                    {TR.cPAdress_postal_code}
                                </Label>
                                <Input
                                    style={{ border: this.state.invoiceZip.length < 3 ? '1px solid red' : 'inherit' }}
                                    bsSize={'sm'}
                                    id="invoiceZip"
                                    name="invoiceZip"
                                    type="text"
                                    placeholder="PLZ"
                                    defaultValue={this.props.courseProvider.InvoiceZip}
                                    onChange={this.inputHandler}
                                />
                            </Col>
                            <Col md={3} className=" mb-1">
                                <Label style={{ color: this.state.invoiceCity.length < 3 ? 'red' : 'inherit' }}>
                                    {TR.cPAdress_city}
                                </Label>
                                <Input
                                    style={{ border: this.state.invoiceCity.length < 3 ? '1px solid red' : 'inherit' }}
                                    bsSize={'sm'}
                                    id="invoiceCity"
                                    name="invoiceCity"
                                    type="text"
                                    placeholder="Ort"
                                    defaultValue={this.props.courseProvider.InvoiceCity}
                                    onChange={this.inputHandler}
                                />
                            </Col>
                            <Col md={3} className=" mb-1">
                                <Label style={{ color: this.state.invoiceCountry.length < 3 ? 'red' : 'inherit' }}>
                                    {TR.cPAdress_country}
                                </Label>
                                <Input
                                    style={{
                                        border: this.state.invoiceCountry.length < 3 ? '1px solid red' : 'inherit',
                                    }}
                                    bsSize={'sm'}
                                    id="invoiceCountry"
                                    name="invoiceCountry"
                                    type="text"
                                    placeholder="Land"
                                    defaultValue={this.props.courseProvider.InvoiceCountry}
                                    onChange={this.inputHandler}
                                />
                            </Col>
                        </>
                    )}

                    <Col md={12}>
                        <span style={{ fontSize: '14px', color: '#666' }}>{TR.cPAdress_enter_address}</span>
                    </Col>
                </Row>
            </>
        );
    };

    private inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newState = {};
        // @ts-ignore
        newState[e.target.id] = e.target.value.trim();
        this.setState(newState);
    };
}



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/CPAdress.tsx